import { Toolbar, ToolbarButton } from 'articleEditor/components/toolbar';
// import toolbarStyles from 'articleEditor/components/toolbar/toolbarButton.module.scss';
import { useFloatingLinkEdit } from 'lib-knowledge-document-structure';
// import { Icon } from '@dixa/lib-shared-habla';

type AnchorLinkDetailsProps = {
  editButtonProps: ReturnType<typeof useFloatingLinkEdit>['editButtonProps'];
  unlinkButtonProps: ReturnType<
    typeof useFloatingLinkEdit
  >['unlinkButtonProps'];
};

export const AnchorLinkDetails = ({
  editButtonProps,
  unlinkButtonProps,
}: AnchorLinkDetailsProps): JSX.Element => {
  return (
    <Toolbar>
      <ToolbarButton {...editButtonProps} isActive={false}>
        Edit Link
      </ToolbarButton>

      {/* TODO: not sure what open link does for anchor links. */}
      {/* <InterlinkOpenButton
        className={toolbarStyles['toolbarButton']}
        rel="noopener noreferrer"
      >
        <Icon
          className={toolbarStyles['toolbarButtonIcon']}
          name="external-link"
        />
      </InterlinkOpenButton> */}

      <ToolbarButton
        icon="link-slash"
        {...unlinkButtonProps}
        isActive={false}
      />
    </Toolbar>
  );
};
